/**
 * `isMobileLayout`: pantalla de teléfono (< 768px, el md de Bootstrap). Reactivo a rotar
 * el teléfono o achicar la ventana. Las pantallas lo usan para mostrar su versión mobile
 * (components/mobile/*) en lugar de la de escritorio, sin tocar esta última.
 */
import "@/components/mobile/mobileTokens.css";

export const MOBILE_LAYOUT_QUERY = "(max-width: 767.98px)";

export default {
  data() {
    return {
      isMobileLayout:
        typeof window !== "undefined" && window.matchMedia
          ? window.matchMedia(MOBILE_LAYOUT_QUERY).matches
          : false,
    };
  },
  mounted() {
    if (typeof window === "undefined" || !window.matchMedia) return;
    this._mobileLayoutMql = window.matchMedia(MOBILE_LAYOUT_QUERY);
    this._onMobileLayoutChange = (e) => {
      this.isMobileLayout = e.matches;
    };
    if (this._mobileLayoutMql.addEventListener) {
      this._mobileLayoutMql.addEventListener("change", this._onMobileLayoutChange);
    } else {
      this._mobileLayoutMql.addListener(this._onMobileLayoutChange);
    }
  },
  beforeDestroy() {
    if (!this._mobileLayoutMql) return;
    if (this._mobileLayoutMql.removeEventListener) {
      this._mobileLayoutMql.removeEventListener("change", this._onMobileLayoutChange);
    } else {
      this._mobileLayoutMql.removeListener(this._onMobileLayoutChange);
    }
  },
};
